const en = {
  grade: "K",
  gradeMini: "K",
  gradeMid: "K",
  class: "Class",
  all: "All",
  no_restrictions: "No restrictions"
};
const zh_hant = {
  grade: "年級",
  gradeMini: "小",
  gradeMid: "中",
  class: "班級",
  all: "全部",
  no_restrictions: "不限"
};
const zh_cn = {
  grade: "年级",
  gradeMini: "小",
  gradeMid: "中",
  class: "班级",
  all: "全部",
  no_restrictions: "不限"
};
const es = {
  grade: "Grado",
  gradeMini: "Pequeño",
  gradeMid: "Medio",
  class: "Clase",
  all: "Todos",
  no_restrictions: "Sin restricciones"
};
export default { en, zh_hant, zh_cn, es };
